import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRefreshInterface = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-refresh-interface';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "inherit",
    viewBox: "0 0 20 20",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M15.122 7.172c.069.158-.051.328-.223.328H13.55a.25.25 0 0 0-.198.402l2.694 3.5a.25.25 0 0 0 .198.098h.524a.25.25 0 0 0 .198-.098l2.695-3.5a.25.25 0 0 0-.199-.402h-1.93a.26.26 0 0 1-.247-.193C16.477 4.26 13.525 2 10.008 2 6.95 2 4.317 3.709 3.151 6.16a.24.24 0 0 0 .221.34h1.74a.26.26 0 0 0 .213-.115C6.272 4.982 7.965 4 10.007 4c2.406 0 4.329 1.363 5.115 3.172M4.933 12c-.16 0-.28.15-.233.303C5.32 14.366 7.373 16 10.007 16c2.266 0 4.102-1.209 4.966-2.86A.26.26 0 0 1 15.2 13h1.655c.169 0 .289.165.23.323C16.057 16.047 13.276 18 10.006 18c-3.7 0-6.773-2.5-7.388-5.788A.26.26 0 0 0 2.37 12H.5a.25.25 0 0 1-.198-.402l2.695-3.5A.25.25 0 0 1 3.195 8h.523a.25.25 0 0 1 .198.098l2.695 3.5a.25.25 0 0 1-.198.402z",
      clipRule: "evenodd"
    })
  }));
});
export default SvgRefreshInterface;